var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.customer)?_c('div',{staticClass:"sidebar-header"},[_vm._v("\n  "+_vm._s(_vm.customer.name)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }